<template>
  <div
    v-if="checkField('first_name')"
    class="summary_item_wrapper mb-0 h-max !max-w-none pb-0"
    :class="errors.first_name ? 'error' : ''"
  >
    <span class="summary_item_title">First Name:</span>
    <Field
      type="text"
      v-model="orderData.first_name"
      @beforeinput="utils.isLetter($event)"
      class="summary_item_input dark:bg-background max-w-full border bg-[#E8EDE8]/50 disabled:border-[#878787] disabled:!text-[#878787] dark:border-[#3D4043] dark:!text-white dark:disabled:!text-[#878787]"
      maxlength="50"
      name="first_name"
      placeholder="First Name"
      :disabled="!isEditable"
    />
  </div>
  <div
    v-if="checkField('last_name')"
    class="summary_item_wrapper mb-0 h-max !max-w-none pb-0"
    :class="errors.last_name ? 'error' : ''"
  >
    <span class="summary_item_title">Last Name:</span>
    <Field
      type="text"
      v-model="orderData.last_name"
      @beforeinput="utils.isLetter($event)"
      class="summary_item_input dark:bg-background max-w-full border bg-[#E8EDE8]/50 disabled:border-[#878787] disabled:!text-[#878787] dark:border-[#3D4043] dark:!text-white dark:disabled:!text-[#878787]"
      name="last_name"
      maxlength="50"
      placeholder="Last Name"
      :disabled="!isEditable"
    />
  </div>
  <div
    v-if="checkField('email')"
    class="summary_item_wrapper mb-0 h-max !max-w-none pb-0"
    :class="errors.email ? 'error' : ''"
  >
    <span class="summary_item_title">Email:</span>
    <Field
      type="text"
      v-model="orderData.email"
      class="summary_item_input dark:bg-background max-w-full border bg-[#E8EDE8]/50 disabled:border-[#878787] disabled:!text-[#878787] dark:border-[#3D4043] dark:!text-white dark:disabled:!text-[#878787]"
      name="email"
      placeholder="Email"
      :disabled="!isEditable"
    />
  </div>
  <div
    :class="{ hide_phone: !hasPhone }"
    v-if="checkField('phone') && route.name == 'success'"
    class="summary_item_wrapper mb-0 h-max !max-w-none pb-0"
  >
    <span class="summary_item_title">Phone:</span>
    <vue-tel-input
      v-model="orderData.phone"
      class="vue-tel-input summary_item_input dark:bg-background max-w-full bg-[#E8EDE8]/50"
      @onInput="onInputPhone"
      @country-changed="countryChanged"
      v-on:beforeinput="validPhone($event, orderData.country_prefix)"
      :defaultCountry="orderData.country_prefix ? orderData.country_prefix : ''"
      v-bind="defaultSettingsVueTel"
      :inputOptions="{
        placeholder: 'Phone',
        styleClasses:
          '!py-5 border disabled:border-[#878787] disabled:!text-[#878787] dark:border-[#3D4043] dark:!text-white dark:disabled:!text-[#878787]'
      }"
      :disabled="!isEditable"
    >
    </vue-tel-input>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { Field } from 'vee-validate'
import { inject, ref } from 'vue'
import { useRoute } from 'vue-router'
import { AsYouType } from 'libphonenumber-js'
import { validPhone } from '@/plugins/validPhone'
import { useOrderStore } from '@/stores'

const route = useRoute()
const utils = inject('utils')
const orderStore = useOrderStore()
const { orderData, hasPhone } = storeToRefs(orderStore)

defineProps({
  isEditable: {
    type: Boolean,
    default: false
  },
  errors: {
    type: Object,
    default: () => ({})
  },
  checkField: {
    type: Function,
    required: true
  }
})

const phoneNationalNumber = ref('')
const preferredCountries = ['us', 'it', 'au', 'uk', 'in', 'ca', 'il', 'sg', 'ae']
const defaultSettingsVueTel = {
  preferredCountries: preferredCountries,
  inputClasses: 'input',
  dropdownOptions: {
    showFlags: true,
    showDialCodeInList: true,
    showDialCodeInSelection: true
  }
}

const onInputPhone = (number, phoneObject) => {
  orderData.value.phone = new AsYouType(phoneObject.country.iso2).input(number)
  phoneNationalNumber.value = phoneObject.nationalNumber || ''
}

const countryChanged = (country) => {
  orderData.value.code = country.dialCode
  orderData.value.country_prefix = country.iso2
}

defineExpose({
  phoneNationalNumber
})
</script>
